$shm_hitalama_vk_token_view $mol_view
	token $shm_hitalama_vk_token
	title <= user_id \
	sub /
		<= Logo $mol_image
			uri <= logo_uri \/shm/hitalama/vk/token/logo/logo_vk.svg
		- <= User_id $mol_paragraph
			title <= user_id \
		<= Avatar $mol_image
			uri <= avatar_url \
			title <= user_id \
